import { formatDate } from "@angular/common";
import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";

export function createRecurrentTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string, defaultFilter?: any } = {}
): TableConfig {
  const {
    onCreate = () => { },
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate = () => { },
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  return {
    columns: columns,
    actions: [
      { label: 'PDF', icon: 'dvr', callback: row => handleAction(row, TableRowAction.Pdf) },
      { label: 'Editar', icon: 'edit', callback: row => handleAction(row, TableRowAction.Edit) },
      { label: 'Eliminar', icon: 'delete', callback: row => handleAction(row, TableRowAction.Delete) },
    ],
    gridActions: gridActions,
    headerActions: headerActions,
    filterView: options.filterView || 'viewSummaryRecurrentFilters',
    defaultFilter: options.defaultFilter || {},
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: false,
    summaryTemplate: summaryTemplate
  };
}

export enum TableRowAction {
  Pdf = 'pdf',
  Edit = 'edit',
  Delete = 'delete',
}
